import { IS_DEVELOPMENT_ENV, IS_PRODUCTION_ENV, IS_TEST_ENV, USE_LOCAL_BE } from './EnvConfig';
import { LOCAL_BE_HOST } from './runtimeConfig';

export const HTMLEditorApiKey = 'auolhv0aeh882fj8twntv4kbcgh328qauwjx9u8mrfzizwjz';
export const LogrocketLoggingEnabled = false;
export const requiredKeycloakRoles = ['diremouser'];

export enum ServiceName {
  Certificate = 'certificate',
  CorridorContact = 'diremo-corridorcontact',
  Diremo = 'diremo',
  DiremoAppBackend = 'diremo-app-backend',
  DiremoCommonDomain = 'diremo-common-domain',
  DiremoExternalApi = 'diremo-external-api',
  Diremoservice = 'diremoservice',
  Document = 'document',
  Form = 'form',
  Identity = 'identity',
  Imd = 'diremo-imd',
  Message = 'message',
  Notes = 'notes',
  Query = 'query',
  RecurringTask = 'diremo-recurringtask',
  RuntimeBundle1 = 'runtime-bundle-1',
  Sba = 'diremo-sba',
  Serviceadmin = 'serviceadmin',
  StudyControl = 'diremo-studycontrol',
}

type ServiceConfig = {
  name: ServiceName;
  url: string;
};

const localDevRestApiURL: Record<ServiceName, ServiceConfig> = {
  [ServiceName.Diremo]: { name: ServiceName.Diremo, url: `${LOCAL_BE_HOST}:8090/redimo/` },
  [ServiceName.Serviceadmin]: {
    name: ServiceName.Serviceadmin,
    url: `${LOCAL_BE_HOST}:8060/diremo-serviceadmin/`,
  },
  [ServiceName.Message]: {
    name: ServiceName.Message,
    url: `${LOCAL_BE_HOST}:8070/diremo-message/`,
  },
  [ServiceName.Form]: { name: ServiceName.Form, url: `${LOCAL_BE_HOST}:8085/diremo-form/` },
  [ServiceName.Imd]: { name: ServiceName.Imd, url: `${LOCAL_BE_HOST}:8032/diremo-imd/` },
  [ServiceName.Query]: {
    name: ServiceName.Query,
    url: `${LOCAL_BE_HOST}:8082/activiti-cloud-query/`,
  },
  [ServiceName.Identity]: {
    name: ServiceName.Identity,
    url: `${LOCAL_BE_HOST}:8084/identity-adapter-service/`,
  },
  [ServiceName.Document]: {
    name: ServiceName.Document,
    url: `${LOCAL_BE_HOST}:8095/diremo-document/`,
  },
  [ServiceName.Notes]: {
    name: ServiceName.Notes,
    url: `${LOCAL_BE_HOST}:8092/diremo-notes/`,
  },
  [ServiceName.Certificate]: {
    name: ServiceName.Certificate,
    url: `${LOCAL_BE_HOST}:8050/diremo-certificate/`,
  },
  [ServiceName.Diremoservice]: {
    name: ServiceName.Diremoservice,
    url: `${LOCAL_BE_HOST}:8030/diremo-service/`,
  },
  [ServiceName.DiremoAppBackend]: {
    name: ServiceName.DiremoAppBackend,
    url: `${LOCAL_BE_HOST}:8020/diremo-app-backend/`,
  },
  [ServiceName.RuntimeBundle1]: {
    name: ServiceName.RuntimeBundle1,
    url: `${LOCAL_BE_HOST}/`,
  },
  [ServiceName.DiremoExternalApi]: {
    name: ServiceName.DiremoExternalApi,
    url: `${LOCAL_BE_HOST}:8080/redimo/`,
  },
  [ServiceName.DiremoCommonDomain]: {
    name: ServiceName.DiremoCommonDomain,
    url: `${LOCAL_BE_HOST}:8022/diremo-common-domain/`,
  },
  [ServiceName.CorridorContact]: {
    name: ServiceName.CorridorContact,
    url: `${LOCAL_BE_HOST}:8023/diremo-corridorcontact/`,
  },
  [ServiceName.RecurringTask]: {
    name: ServiceName.RecurringTask,
    url: `${LOCAL_BE_HOST}:8033/diremo-recurringtask/`,
  },
  [ServiceName.Sba]: {
    name: ServiceName.Sba,
    url: `${LOCAL_BE_HOST}:8086/diremo-sba/`,
  },
  [ServiceName.StudyControl]: {
    name: ServiceName.StudyControl,
    url: `${LOCAL_BE_HOST}:8024/diremo-studycontrol/`,
  },
};

const deployedDevRestApiURL: Record<ServiceName, ServiceConfig> = {
  [ServiceName.Diremo]: {
    name: ServiceName.Diremo,
    url: 'https://diremoutv.afbostader.se/redimo/',
  },
  [ServiceName.Serviceadmin]: {
    name: ServiceName.Serviceadmin,
    url: 'https://diremoutv.afbostader.se/diremo-serviceadmin/',
  },
  [ServiceName.Message]: {
    name: ServiceName.Message,
    url: 'https://diremoutv.afbostader.se/diremo-message/',
  },
  [ServiceName.Form]: {
    name: ServiceName.Form,
    url: 'https://diremoutv.afbostader.se/diremo-form/',
  },
  [ServiceName.Imd]: { name: ServiceName.Imd, url: 'https://diremoutv.afbostader.se/diremo-imd/' },
  [ServiceName.Query]: {
    name: ServiceName.Query,
    url: 'https://diremoutv.afbostader.se/activiti-cloud-query/',
  },
  [ServiceName.Identity]: {
    name: ServiceName.Identity,
    url: 'https://diremoutv.afbostader.se/identity-adapter-service/',
  },
  [ServiceName.Document]: {
    name: ServiceName.Document,
    url: 'https://diremoutv.afbostader.se/diremo-document/',
  },
  [ServiceName.Notes]: {
    name: ServiceName.Notes,
    url: 'https://diremoutv.afbostader.se/diremo-notes/',
  },
  [ServiceName.Certificate]: {
    name: ServiceName.Certificate,
    url: 'https://diremoutv.afbostader.se/diremo-certificate/',
  },
  [ServiceName.Diremoservice]: {
    name: ServiceName.Diremoservice,
    url: 'https://diremoutv.afbostader.se/diremo-service/',
  },
  [ServiceName.DiremoAppBackend]: {
    name: ServiceName.DiremoAppBackend,
    url: 'https://diremoutv.afbostader.se/diremo-app-backend/',
  },
  [ServiceName.RuntimeBundle1]: {
    name: ServiceName.RuntimeBundle1,
    url: 'https://diremoutv.afbostader.se/',
  },
  [ServiceName.DiremoExternalApi]: {
    name: ServiceName.DiremoExternalApi,
    url: 'https://apiutv.afbostader.se/redimo/',
  },
  [ServiceName.DiremoCommonDomain]: {
    name: ServiceName.DiremoCommonDomain,
    url: 'https://diremoutv.afbostader.se/diremo-common-domain/',
  },
  [ServiceName.CorridorContact]: {
    name: ServiceName.CorridorContact,
    url: 'https://diremoutv.afbostader.se/diremo-corridorcontact/',
  },
  [ServiceName.RecurringTask]: {
    name: ServiceName.RecurringTask,
    url: 'https://diremoutv.afbostader.se/diremo-recurringtask/',
  },
  [ServiceName.Sba]: {
    name: ServiceName.Sba,
    url: 'https://diremoutv.afbostader.se/diremo-sba/',
  },
  [ServiceName.StudyControl]: {
    name: ServiceName.StudyControl,
    url: 'https://diremoutv.afbostader.se/diremo-studycontrol/',
  },
};

const devBaseRestApiURL = USE_LOCAL_BE ? localDevRestApiURL : deployedDevRestApiURL;

const prodBaseRestApiURL: Record<ServiceName, ServiceConfig> = {
  [ServiceName.Diremo]: { name: ServiceName.Diremo, url: 'https://diremo.afbostader.se/redimo/' },
  [ServiceName.Serviceadmin]: {
    name: ServiceName.Serviceadmin,
    url: 'https://diremo.afbostader.se/diremo-serviceadmin/',
  },
  [ServiceName.Message]: {
    name: ServiceName.Message,
    url: 'https://diremo.afbostader.se/diremo-message/',
  },
  [ServiceName.Form]: { name: ServiceName.Form, url: 'https://diremo.afbostader.se/diremo-form/' },
  [ServiceName.Imd]: { name: ServiceName.Imd, url: 'https://diremo.afbostader.se/diremo-imd/' },
  [ServiceName.Query]: {
    name: ServiceName.Query,
    url: 'https://diremo.afbostader.se/activiti-cloud-query/',
  },
  [ServiceName.Identity]: {
    name: ServiceName.Identity,
    url: 'https://diremo.afbostader.se/identity-adapter-service/',
  },
  [ServiceName.Document]: {
    name: ServiceName.Document,
    url: 'https://diremo.afbostader.se/diremo-document/',
  },
  [ServiceName.Notes]: {
    name: ServiceName.Notes,
    url: 'https://diremo.afbostader.se/diremo-notes/',
  },
  [ServiceName.Certificate]: {
    name: ServiceName.Certificate,
    url: 'https://diremo.afbostader.se/diremo-certificate/',
  },
  [ServiceName.Diremoservice]: {
    name: ServiceName.Diremoservice,
    url: 'https://diremo.afbostader.se/diremo-service/',
  },
  [ServiceName.DiremoAppBackend]: {
    name: ServiceName.DiremoAppBackend,
    url: 'https://diremo.afbostader.se/diremo-app-backend/',
  },
  [ServiceName.RuntimeBundle1]: {
    name: ServiceName.RuntimeBundle1,
    url: 'https://diremo.afbostader.se/',
  },
  [ServiceName.DiremoExternalApi]: {
    name: ServiceName.DiremoExternalApi,
    url: 'https://api.afbostader.se/redimo/',
  },
  [ServiceName.DiremoCommonDomain]: {
    name: ServiceName.DiremoCommonDomain,
    url: 'https://diremo.afbostader.se/diremo-common-domain/',
  },
  [ServiceName.CorridorContact]: {
    name: ServiceName.CorridorContact,
    url: 'https://diremo.afbostader.se/diremo-corridorcontact/',
  },
  [ServiceName.RecurringTask]: {
    name: ServiceName.RecurringTask,
    url: 'https://diremo.afbostader.se/diremo-recurringtask/',
  },
  [ServiceName.Sba]: {
    name: ServiceName.Sba,
    url: 'https://diremo.afbostader.se/diremo-sba/',
  },
  [ServiceName.StudyControl]: {
    name: ServiceName.StudyControl,
    url: 'https://diremo.afbostader.se/diremo-studycontrol/',
  },
};

const testBaseRestApiURL: Record<ServiceName, ServiceConfig> = {
  [ServiceName.Diremo]: {
    name: ServiceName.Diremo,
    url: 'https://diremotest.afbostader.se/redimo/',
  },
  [ServiceName.Serviceadmin]: {
    name: ServiceName.Serviceadmin,
    url: 'https://diremotest.afbostader.se/diremo-serviceadmin/',
  },
  [ServiceName.Message]: {
    name: ServiceName.Message,
    url: 'https://diremotest.afbostader.se/diremo-message/',
  },
  [ServiceName.Form]: {
    name: ServiceName.Form,
    url: 'https://diremotest.afbostader.se/diremo-form/',
  },
  [ServiceName.Imd]: { name: ServiceName.Imd, url: 'https://diremotest.afbostader.se/diremo-imd/' },
  [ServiceName.Query]: {
    name: ServiceName.Query,
    url: 'https://diremotest.afbostader.se/activiti-cloud-query/',
  },
  [ServiceName.Identity]: {
    name: ServiceName.Identity,
    url: 'https://diremotest.afbostader.se/identity-adapter-service/',
  },
  [ServiceName.Document]: {
    name: ServiceName.Document,
    url: 'https://diremotest.afbostader.se/diremo-document/',
  },
  [ServiceName.Notes]: {
    name: ServiceName.Notes,
    url: 'https://diremotest.afbostader.se/diremo-notes/',
  },
  [ServiceName.Certificate]: {
    name: ServiceName.Certificate,
    url: 'https://diremotest.afbostader.se/diremo-certificate/',
  },
  [ServiceName.Diremoservice]: {
    name: ServiceName.Diremoservice,
    url: 'https://diremotest.afbostader.se/diremo-service/',
  },
  [ServiceName.DiremoAppBackend]: {
    name: ServiceName.DiremoAppBackend,
    url: 'https://diremotest.afbostader.se/diremo-app-backend/',
  },
  [ServiceName.RuntimeBundle1]: {
    name: ServiceName.RuntimeBundle1,
    url: 'https://diremotest.afbostader.se/',
  },
  [ServiceName.DiremoExternalApi]: {
    name: ServiceName.DiremoExternalApi,
    url: 'https://apitest.afbostader.se/redimo/',
  },
  [ServiceName.DiremoCommonDomain]: {
    name: ServiceName.DiremoCommonDomain,
    url: 'https://diremotest.afbostader.se/diremo-common-domain/',
  },
  [ServiceName.CorridorContact]: {
    name: ServiceName.CorridorContact,
    url: 'https://diremotest.afbostader.se/diremo-corridorcontact/',
  },
  [ServiceName.RecurringTask]: {
    name: ServiceName.RecurringTask,
    url: 'https://diremotest.afbostader.se/diremo-recurringtask/',
  },
  [ServiceName.Sba]: {
    name: ServiceName.Sba,
    url: 'https://diremotest.afbostader.se/diremo-sba/',
  },
  [ServiceName.StudyControl]: {
    name: ServiceName.StudyControl,
    url: 'https://diremotest.afbostader.se/diremo-studycontrol/',
  },
};

const labBaseRestApiURL: Record<ServiceName, ServiceConfig> = {
  [ServiceName.Diremo]: { name: ServiceName.Diremo, url: '/redimo/' },
  [ServiceName.Serviceadmin]: { name: ServiceName.Serviceadmin, url: '/diremo-serviceadmin/' },
  [ServiceName.Message]: { name: ServiceName.Message, url: '/diremo-message/' },
  [ServiceName.Form]: { name: ServiceName.Form, url: '/diremo-form/' },
  [ServiceName.Imd]: { name: ServiceName.Imd, url: '/diremo-imd/' },
  [ServiceName.Query]: { name: ServiceName.Query, url: '/activiti-cloud-query/' },
  [ServiceName.Identity]: { name: ServiceName.Identity, url: '/identity-adapter-service/' },
  [ServiceName.Document]: { name: ServiceName.Document, url: '/diremo-document/' },
  [ServiceName.Notes]: { name: ServiceName.Document, url: '/diremo-notes/' },
  [ServiceName.Certificate]: { name: ServiceName.Document, url: '/diremo-certificate/' },
  [ServiceName.Diremoservice]: { name: ServiceName.Document, url: '/diremo-service/' },
  [ServiceName.DiremoAppBackend]: {
    name: ServiceName.DiremoAppBackend,
    url: '/diremo-app-backend/',
  },
  [ServiceName.RuntimeBundle1]: { name: ServiceName.RuntimeBundle1, url: '/' },
  [ServiceName.DiremoExternalApi]: { name: ServiceName.DiremoExternalApi, url: '/redimo/' },
  [ServiceName.DiremoCommonDomain]: {
    name: ServiceName.DiremoCommonDomain,
    url: '/diremo-common-domain/',
  },
  [ServiceName.CorridorContact]: {
    name: ServiceName.CorridorContact,
    url: '/diremo-corridorcontact/',
  },
  [ServiceName.RecurringTask]: {
    name: ServiceName.RecurringTask,
    url: '/diremo-recurringtask/',
  },
  [ServiceName.Sba]: { name: ServiceName.Sba, url: '/diremo-sba/' },
  [ServiceName.StudyControl]: { name: ServiceName.StudyControl, url: '/diremo-studycontrol/' },
};

export const baseRestApiURL = IS_PRODUCTION_ENV
  ? prodBaseRestApiURL
  : IS_TEST_ENV
  ? testBaseRestApiURL
  : IS_DEVELOPMENT_ENV
  ? devBaseRestApiURL
  : labBaseRestApiURL;

export const getServiceUrl = (serviceName: ServiceName | string): string => {
  const service = baseRestApiURL[serviceName as ServiceName];
  if (!service) {
    return baseRestApiURL[ServiceName.RuntimeBundle1].url + serviceName + '/';
  }
  return service.url;
};

export const getServiceName = (name: `${ServiceName}`): ServiceName => {
  return name as ServiceName;
};
